import UserDriverEditNotesRequest, {
  UserDriverEditNotesRequestBody,
} from "./user-driver-edit-notes.request";

const createBody = (
  request: UserDriverEditNotesRequest,
): UserDriverEditNotesRequestBody => {
  return {
    notes: request.notes,
  };
};

const userDriverEditNotesRequestFactory = {
  createBody,
};

export default userDriverEditNotesRequestFactory;
